var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics container"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"data"},[_c('p',{staticClass:"data_title"},[_vm._v("学情统计")]),_c('table',{attrs:{"width":"100%","border":"1","cellspacing":"0","cellpadding":"20","align":"center"}},[_vm._m(0),_c('tr',{staticStyle:{"text-align":"center"}},[_c('td',{on:{"click":function($event){return _vm.$router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ..._vm.$route.query,
                  type: 'video',
                },
              })}}},[_vm._v(" "+_vm._s(_vm.statisticsinfo.videoRate)+"% ")]),_c('td',{on:{"click":function($event){return _vm.$router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ..._vm.$route.query,
                  type: 'ppt',
                },
              })}}},[_vm._v(" "+_vm._s(_vm.statisticsinfo.pptRate)+"% ")]),_c('td',{on:{"click":function($event){return _vm.$router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ..._vm.$route.query,
                  type: 'test',
                },
              })}}},[_vm._v(" "+_vm._s(_vm.statisticsinfo.testRate)+"% ")]),_c('td',{on:{"click":function($event){return _vm.$router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ..._vm.$route.query,
                  type: 'works',
                },
              })}}},[_vm._v(" "+_vm._s(_vm.statisticsinfo.szRate)+"% ")])])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',{staticStyle:{"font-weight":"bold","text-align":"center","background":"#d8d8d8"}},[_c('td',[_vm._v("微课")]),_c('td',[_vm._v("PPT")]),_c('td',[_vm._v("练习")]),_c('td',[_vm._v("实操")])])
}]

export { render, staticRenderFns }